import axios from "axios";

const api = axios.create({
    // Root of your ASP.NET Core API
     //baseURL: "https://localhost:7075/api",
    baseURL: "http://msreceipt.runasp.net/api",
    headers: {
      "Content-Type": "application/json"
    }
  });
  
  

// Attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;